<template>
  <div class="liveVideo">
    <div class="main-container">
      <div class="videoScreen liveScreen">
        <div class="selectMusic">
          <AgoraVideoCall
            v-if="attendeeMode == 'video'"
            ref="money91"
            :videoProfile="videoProfile"
            :channel="channel"
            :transcode="transcode"
            :attendeeMode="attendeeMode"
            :baseMode="baseMode"
            :appId="appId"
            :uid="uid"
          />
          <AgoraViewer
            v-if="attendeeMode == 'audience'"
            :videoProfile="videoProfile"
            :channel="channel"
            :transcode="transcode"
            :attendeeMode="attendeeMode"
            :baseMode="baseMode"
            :appId="appId"
            :uid="uid"
            :source="source"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie'
import Loading from 'vue-loading-overlay'
import AgoraVideoCall from '@/components/AgoraVideoCall'
import AgoraViewer from '@/components/AgoraViewer'
import { AGORA_APP_ID } from '@/agora.config'

export default {
  name: 'liveVideo',

  props: {
    msg: String
  },

  components: {
    AgoraVideoCall,
    AgoraViewer,
    Loading
  },
  data() {
    return {
      videoProfile: '720p',
      transcode: 'interop',
      baseMode: 'al',
      uid: 0,
      channel: this.$route.query.c,
      attendeeMode: this.$route.query.u,
      isLoading: true,
      source: this.$route.query.src
    }
  },

  created() {
    this.appId = AGORA_APP_ID
    if (!this.appId) {
      return alert(this.$t('appId'))
    }
  }
}
</script>

<style scoped>
.ag-item {
  border: none;
  background: transparent;
}
.liveScreen .selectMusic {
  text-align: left !important;
}
</style>
